export class PayBillModel {
  public orderBillId: string;
  public venueId: string;
  public paymentType: number;
  public amountReceived: number;
  public amountReturned: number;
}
